import request from 'utils/request';

type Icons8IconData = {
  id: string;

  // Will be used to block explicit icons (in E1 we filter out "Explicit", and "Sex Toy")
  category: string;
  platform: string;
  commonName: string;
  sourceFormat: string;
  isColor: boolean;
};

export type Icons8SearchResponse = {
  success: boolean;
  icons: Icons8IconData[];
  parameters: {
    // Number of documents that were returned
    amount: number;

    // Number of total documents for the specified query + filter
    countAll: number;

    offset: number;
  };
};

// Search params to pass into icons8_search E1 Endpoint
export type Icons8SearchParams = {
  query: string;
  limit: number;
  offset: number;
  isColor?: boolean;
};

type Icons8DownloadResponse = {};

const BASE_PATH = '/infographics';

/**
 * Perform Icons8 search
 */
export const icons8Search = async (searchParams: Icons8SearchParams) => {
  const { query, limit, offset, isColor } = searchParams;

  let requestURL = `${BASE_PATH}/icons8_search/${query}/${limit}/${offset}/`;

  // isColor used to filter between mono and color icons
  // To skip filtering, need to set to 'null'
  if (isColor !== undefined) {
    requestURL += isColor;
  } else {
    requestURL += null;
  }

  return await request<Icons8SearchResponse>(requestURL, {
    method: 'GET',
  });
};

/**
 * Trigger download request for the specified icon
 * If `countQuota` is specified to true, will count towards our paid icons8 quota
 *
 * @param iconId
 * @param countQuota Whether to use up our Icons8 quota for this request
 * @returns
 */
export const icons8Download = async (iconId: string, countQuota?: boolean) => {
  let requestURL = `${BASE_PATH}/icons8_download/${iconId}`;

  if (countQuota) {
    requestURL += '?countQuota=true';
  }

  return await request<Icons8DownloadResponse>(requestURL, {
    method: 'GET',
  });
};
